// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"ecb5c432","404":"55c70c45"}[chunkId] + ".chunk.js";
};